module.exports = __webpack_public_path__ + "img/wallart.c2b5193d.png";